<template>
  <v-list-item
    :[linkAttribute]="menuItem.link"
    active-class="text-primary"
    link
    :prepend-icon="menuItem.icon"
    :title="menuItem.text"
    @click="trackEvent(menuItem.event)"
  >
    <template #append>
      <v-badge inline dot :model-value="showBadge" color="primary" />
    </template>
  </v-list-item>
</template>

<script lang="ts">
import { MenuItem } from '@/components/navigation/menu'
import { trackEvent } from '@/modules/tracking/useTracking'
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SideMenuItem',
  props: {
    menuItem: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    externalLink: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    if (props.menuItem.count) {
      props.menuItem.count.loadFunction()
    }

    const linkAttribute = computed(() => (props.externalLink ? 'href' : 'to'))

    const showBadge = computed(
      () => props.menuItem.count != undefined && props.menuItem.count.getter() > 0
    )

    return {
      showBadge,
      trackEvent,
      linkAttribute
    }
  }
})
</script>
